import { Tooltip } from "@material-ui/core";

const IconEstado = (props) => {
  let backgroundColor = "green";

  if (props.backgroundColor === "warning") {
    backgroundColor = "orange";
  }
  if (props.backgroundColor === "error") {
    backgroundColor = "red";
  }

  return (
    <Tooltip title={props.descripcion}>
      <span
        style={{
          color: "white",
          fontWeight: "bold",
          fontSize: "0.9rem",
          // backgroundColor: `${backgroundColor}`,
          backgroundColor: `${props.useColorTable ? props.backgroundColor : backgroundColor}`,
          borderRadius: "0.25rem",
          padding: "0.5rem",
          marginRight: props.extraMarginRight ? "0.25rem" : "0",
        }}
      >
        {props.texto}
      </span>
    </Tooltip>
  );
};

export default IconEstado;
